





















import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({})
export default class CreditNumberInput extends Vue {
  @Prop({ default: '' }) private value!: string
  @Prop({ default: false }) private readonly!: boolean
  @Prop({ default: '' }) private error!: string

  private get displayValue() {
    const digits = (this.value || '').replace(/\D+/g, '').slice(0, 16)
    return digits.replace(/(\d{4})(?=\d)/g, '$1 ').trim()
  }

  private onInput(e: Event) {
    const target = e.target as HTMLInputElement
    const raw = target ? target.value : ''
    const digits = (raw || '').replace(/\D+/g, '').slice(0, 16)
    this.$emit('input', digits)
  }
}
